import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgKey = function SvgKey(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#key_svg__clip0)"
  }, React.createElement("path", {
    d: "M12.045 7.77l2.973 2.973.975-.976h2.973a.981.981 0 00.975-.975V5.82h2.972a.981.981 0 00.976-.976V2.29a.945.945 0 00-.28-.697l-.417-.418a.945.945 0 00-.697-.279h-3.111a.945.945 0 00-.697.28L12.045 7.77zM14.182 12.88L9.909 8.605a3.952 3.952 0 00-5.573 0l-3.298 3.298a3.953 3.953 0 000 5.573l4.273 4.273a3.952 3.952 0 005.573 0l3.298-3.298c1.579-1.532 1.579-3.994 0-5.573zm-4.598 7.244a2.075 2.075 0 01-2.973 0l-3.947-3.947a2.075 2.075 0 010-2.973 2.075 2.075 0 012.972 0l3.948 3.948c.836.836.836 2.183 0 2.972z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "key_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgKey;